module.exports = __webpack_public_path__ + "img/badge-list-thumb-006.06ae4e9f.png";